import * as React from 'react';
import {Query, Mutation} from 'react-apollo';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {
    ConditionInput,
    GetOpenLeadSlackMessage as GetOpenLeadSlackMessageQuery,
    GetOpenLeadSlackMessageVariables as GetOpenLeadSlackMessageQueryVariables,
    CreateOpenLeadSlackMessage as CreateOpenLeadSlackMessageMutation,
    CreateOpenLeadSlackMessageVariables as CreateOpenLeadSlackMessageMutationVariables,
    UpdateOpenLeadSlackMessage as UpdateOpenLeadSlackMessageMutation,
    UpdateOpenLeadSlackMessageVariables as UpdateOpenLeadSlackMessageMutationVariables,
    DeleteOpenLeadSlackMessage as DeleteOpenLeadSlackMessageMutation,
    DeleteOpenLeadSlackMessageVariables as DeleteOpenLeadSlackMessageMutationVariables,
} from 'nutshell-graphql-types';

import {refetchSalesAutomationOpenLeadQueries} from '../../app/sales-automation-open-leads';
import CREATE_OPEN_LEAD_SLACK_MESSAGE from '../../graphql/mutations/create-open-lead-slack-message.graphql';
import DELETE_OPEN_LEAD_SLACK_MESSAGE from '../../graphql/mutations/delete-open-lead-slack-message.graphql';
import UPDATE_OPEN_LEAD_SLACK_MESSAGE from '../../graphql/mutations/update-open-lead-slack-message.graphql';
import GET_OPEN_LEAD_SLACK_MESSAGE from '../../graphql/queries/get-open-lead-slack-message.graphql';

import {FormSlackGraphQLComponent} from './form-slack-graphql-component';

class SlackMessageQuery extends Query<
    GetOpenLeadSlackMessageQuery,
    GetOpenLeadSlackMessageQueryVariables
> {}

class CreateMutation extends Mutation<
    CreateOpenLeadSlackMessageMutation,
    CreateOpenLeadSlackMessageMutationVariables
> {}

class UpdateMutation extends Mutation<
    UpdateOpenLeadSlackMessageMutation,
    UpdateOpenLeadSlackMessageMutationVariables
> {}

class DeleteMutation extends Mutation<
    DeleteOpenLeadSlackMessageMutation,
    DeleteOpenLeadSlackMessageMutationVariables
> {}

type OwnProps = {
    formSubmitBtnRef: (arg1?: HTMLInputElement | null | undefined) => void;
    parentId: string;
    entityId: string | null | undefined;
};

type RoutedProps = ContextRouter & OwnProps;

export const FormOpenLeadSlackGraphQL = (props: RoutedProps) => {
    const {stagesetId} = props.match.params;
    if (!stagesetId) return null;

    return (
        <SlackMessageQuery
            query={GET_OPEN_LEAD_SLACK_MESSAGE}
            skip={!props.entityId}
            variables={{
                id: props.entityId || '' /* Needed to keep flow happy, won't happen because skip */,
            }}
            // @ts-expect-error
            fetchPolicy='cache-and-network'
        >
            {({data, loading}) => {
                const openLeadSlackMessage = data ? data.openLeadSlackMessage : null;

                return (
                    <CreateMutation
                        mutation={CREATE_OPEN_LEAD_SLACK_MESSAGE}
                        // @ts-expect-error
                        refetchQueries={refetchSalesAutomationOpenLeadQueries({
                            stageId: props.parentId,
                        })}
                    >
                        {(createSlackAutomation) => (
                            <UpdateMutation
                                mutation={UPDATE_OPEN_LEAD_SLACK_MESSAGE}
                                // @ts-expect-error
                                refetchQueries={refetchSalesAutomationOpenLeadQueries({
                                    stageId: props.parentId,
                                })}
                            >
                                {(updateSlackAutomation) => (
                                    <DeleteMutation
                                        mutation={DELETE_OPEN_LEAD_SLACK_MESSAGE}
                                        // @ts-expect-error
                                        refetchQueries={refetchSalesAutomationOpenLeadQueries({
                                            stageId: props.parentId,
                                        })}
                                    >
                                        {(deleteSlackAutomation) => (
                                            <FormSlackGraphQLComponent
                                                stagesetId={stagesetId}
                                                // @ts-expect-error
                                                entityId={props.entityId}
                                                parentId={props.parentId}
                                                isFetchingLatestVersion={loading}
                                                slackMessageAutomation={openLeadSlackMessage}
                                                formSubmitBtnRef={props.formSubmitBtnRef}
                                                onSubmit={(
                                                    channelId: string,
                                                    conditions: ConditionInput[]
                                                ) => {
                                                    const saveStepTemplatePromise =
                                                        openLeadSlackMessage
                                                            ? updateSlackAutomation({
                                                                  variables: {
                                                                      openLeadSlackMessage: {
                                                                          id: openLeadSlackMessage.id,
                                                                          conditions: conditions,
                                                                          channelId: channelId,
                                                                      },
                                                                  },
                                                              })
                                                            : createSlackAutomation({
                                                                  variables: {
                                                                      openLeadSlackMessage: {
                                                                          stageId: props.parentId,
                                                                          conditions: conditions,
                                                                          channelId: channelId,
                                                                      },
                                                                  },
                                                              });

                                                    return saveStepTemplatePromise;
                                                }}
                                                // @ts-expect-error
                                                createSlackAutomation={(slackFormValues) =>
                                                    createSlackAutomation({
                                                        variables: {
                                                            openLeadSlackMessage: slackFormValues,
                                                        },
                                                    })
                                                }
                                                // @ts-expect-error
                                                updateSlackAutomation={(slackFormValues) =>
                                                    updateSlackAutomation({
                                                        variables: {
                                                            openLeadSlackMessage: slackFormValues,
                                                        },
                                                    })
                                                }
                                                deleteSlackAutomation={(slackAutomationId) =>
                                                    deleteSlackAutomation({
                                                        variables: {
                                                            openLeadSlackMessage: {
                                                                id: slackAutomationId,
                                                            },
                                                        },
                                                    })
                                                }
                                            />
                                        )}
                                    </DeleteMutation>
                                )}
                            </UpdateMutation>
                        )}
                    </CreateMutation>
                );
            }}
        </SlackMessageQuery>
    );
};

// @ts-expect-error
export const FormOpenLeadSlack = withRouter<OwnProps>(FormOpenLeadSlackGraphQL);
